<template>
	<div class="home">
		<Header  :isJobs.sync="isJobs"></Header>
		<router-view />
<!--		<Footer ></Footer>-->
	</div>
</template>

<script>
	import Header from "@/components/layout/header";
	import Content from "@/components/layout/content/index";
	// import Footer from "@/components/layout/footer";
	export default {
		name: "Home",
		components: {
			Header,
			Content,
		},
		data() {
			return {
				isScrolling: false,
				chanOpenState: false,
				isJobs: false,
			};
		},
		watch: {
			$route(e){
				if(e.path == '/home/jobs'){
					this.isJobs = true;
				}
			},
			chanOpenState(val) {
				if (val) {
					this.isScrolling = true;
				} else {
					this.isScrolling = false;
				}
			}
		},
    methods:{

    }
	};
</script>
<style scoped>

</style>
